module.exports = __webpack_public_path__ + "img/mi-open-in-new.6b0ccea7.svg";